import React from "react";
import ExistingOrderPage from "../components/ExistingOrderPage";

export default function OrdersCreateComplexTenderPage() {
  return <ExistingOrderPage mode="copy" />;
}
